import React, { useRef, useState } from "react";
import ToggleList from "./ToggleList";
import "./WidgetCollection.scss";
import classNames from "classnames";
import Card from "./Card";
import ImageBox from "./ImageBox";
export default function WidgetCollection({ data, showThumb, productUrl, products, getProduct, setProduct, }) {
    const [dataCategory, setDataCategory] = useState({
        primary: "",
        primary_label: "",
        secondary: "",
        secondary_label: "",
    }); //Macrocategoria + Categoria scelta
    const [idCategoryOpened, setIdCategoryOpened] = useState(-1); //Stato relativo allo specifico toggle aperto/chiuso
    const [isProductsShown, setisProductsShown] = useState(false);
    const refContainer = useRef(null);
    let idCat = 0;
    const isOddLines = data.length & 1 ? true : false;
    const toggleProductCategory = (line, macroCategoryLabel, macroCategoryName, categoryLabel, categoryName, catId) => {
        refContainer.current.scrollIntoView();
        setDataCategory({
            primary_label: macroCategoryLabel,
            primary: macroCategoryName,
            secondary_label: categoryLabel,
            secondary: categoryName,
        });
        setisProductsShown(!isProductsShown);
        setIdCategoryOpened(catId);
        /* Chiamata a funzione js presente in pagina - FUORI DA REACT */
        const evento = window["evento"];
        if (evento) {
            evento("eStore", "Click", "Catalog" + " " + line + " " + macroCategoryName + " " + categoryName + "-", "SL-" + window["lingua"]);
        }
        //Chiamata di rete ai prodotti scelti
        getProduct(line, macroCategoryLabel, categoryLabel, false);
    };
    const goBack = () => {
        /* Reset Stati */
        setDataCategory({
            primary_label: "",
            primary: "",
            secondary_label: "",
            secondary: "",
        });
        setisProductsShown(!isProductsShown);
        setIdCategoryOpened(-1);
        setProduct([]);
    };
    return (React.createElement("div", { ref: refContainer, className: "widget-collection" },
        data.map((line, i) => (React.createElement("div", { key: line.line_name, className: classNames("line", {
                "full-width": isOddLines && i === data.length - 1,
                "rt-hidden": isProductsShown,
            }) },
            React.createElement(ImageBox, { title: line.line_name, imageUrl: isOddLines && i === data.length - 1 ? line.banner_big : line.banner, imageMobile: line.banner }),
            React.createElement("div", { className: classNames("category-subcategory-list", {
                    "rt-hidden": isProductsShown,
                }) }, line.macro_categories.map(macroCategory => (React.createElement(ToggleList, { setIdCategory: setIdCategoryOpened, idCategory: idCategoryOpened, isOpen: idCategoryOpened === idCat, key: idCat, title: macroCategory.macro_category_name, line: line.line_name, id: idCat },
                React.createElement("ul", { className: "macrocategory-list" }, macroCategory.categories.map(subcategory => (React.createElement("li", { key: subcategory.category_label, onClick: () => toggleProductCategory(line.line_label, macroCategory.macro_category_label, macroCategory.macro_category_name, subcategory.category_label, subcategory.category_name, idCat) }, subcategory.category_name)))),
                (() => {
                    idCat++;
                })()))))))),
        isProductsShown && (React.createElement("div", { className: classNames("category-products-list", {
                "rt-hidden": !isProductsShown,
            }) },
            React.createElement("div", { className: "category-products-header" },
                React.createElement("a", { onClick: goBack, className: "go-back" },
                    React.createElement("span", null,
                        "\u2190 ",
                        window["buttonCollezioni"])),
                React.createElement("div", { className: "category-breadcrumbs" },
                    React.createElement("span", { className: "client-name" }, "Catalogo"),
                    " /",
                    " ",
                    React.createElement("span", { className: "category-primary" }, dataCategory.primary),
                    React.createElement("div", { className: "category-secondary" }, dataCategory.secondary)),
                React.createElement("a", { onClick: goBack, className: "close-product-list" },
                    React.createElement("span", null, "X"))),
            React.createElement("div", { className: "products-list-container" }, products.map((item, i) => (React.createElement(Card, { key: i, showThumb: showThumb, item: item, url: productUrl }))))))));
}
